import React from 'react';
import '../../styles/HomePage/about.css';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function About() {

  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/about');
    window.scrollTo(0, 0);
  };

  return (
    <div className="homeabout-container" id="about">
      <div className="homeabout-left">
        <img
          src={require('../../assets/aboutus_image.jpg')}
          alt="Company Image"
          className="homeabout-img"
        />
      </div>
      <div className="homeabout-right">
        <h2 className="homeabout-title">About the Company</h2>
        <p className="homeabout-text">
          <strong>VSK Global Infotech</strong>, is a Europe-based IT consulting and recruitment company helping organizations transform and grow through cutting-edge technology and top-tier talent.
        </p>

        <div className="homeabout-info">
          <p>
            Founded with the goal of making innovation accessible, we operate across Netherlands, Poland, Germany, Belgium, and the UK, offering a unique blend of IT services and skilled workforce solutions tailored to every client's needs.
          </p>
          <br />
          <p>
            <strong>Our Vision:</strong> To be a trusted technology and talent partner powering digital transformation across Europe.
          </p>
          <p style={{ marginTop: '0.6em' }}>
            <strong>Our Mission:</strong> To deliver innovative, secure, and scalable solutions that solve real-world business problems while also connecting clients with the best IT talent available globally.
          </p>
        </div>

        <button onClick={handleNavigate} className="homeabout-button">
          <span>Know more</span>
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
}

export default About;
